import { render, staticRenderFns } from "./AssetSelection.vue?vue&type=template&id=dfff5fa6&scoped=true"
import script from "./AssetSelection.vue?vue&type=script&lang=js"
export * from "./AssetSelection.vue?vue&type=script&lang=js"
import style0 from "./AssetSelection.vue?vue&type=style&index=0&id=dfff5fa6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfff5fa6",
  null
  
)

export default component.exports